import * as ActionTypes from 'actions/uploadlogs'

const initialState = {
  isFetching: false,
  isError: false,
  fetched: false,
  documents: [],
  cpTrustDeeds: [],
  cpLoanPack: [],
  cpAmtConfirmation: [],
}

// Updates error message to notify about the failed fetches.
export default function getUploadLogs(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.UPLOADLOGS_GETING_LOGS:
      return Object.assign({}, state, {
        isFetching: true,
      })
    case ActionTypes.UPLOADLOGS_RECEIVED_LOGS:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        documents: action.documents,
      }
    case ActionTypes.UPLOADLOGS_CPTRUSTDEEDS_RECEIVED_LOGS:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        cpTrustDeeds: action.documents,
      }
    case ActionTypes.UPLOADLOGS_CPLOANPACK_RECEIVED_LOGS:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        cpLoanPack: action.documents,
      }
    case ActionTypes.UPLOADLOGS_CPAMTCONFIRMATION_RECEIVED_LOGS:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        cpAmtConfirmation: action.documents,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/uploadlogs.js